import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { getIdToken } from './auth/authProvider';

export type IApiEnpointConfig = {
    baseUrl: string;
    authProvider: PublicClientApplication;
    scopes: string[];
    useAccessToken?: boolean;
};

/**
 * Axios API Client
 * @description API Client to connect to Azure AD / Azure APIs
 * @class ApiClient
 */
class ApiClient {
    public client: AxiosInstance;
    public config: IApiEnpointConfig;
    public authProvider: PublicClientApplication;

    constructor(clientConfig: IApiEnpointConfig) {
        this.client = Axios.create({
            baseURL: clientConfig.baseUrl,
        });
        this.authProvider = clientConfig.authProvider;
        this.config = clientConfig;
        this.client.interceptors.request.use(this.requestSuccess, this.requestFail);
        this.client.interceptors.response.use(this.responseSuccess, this.responseFail);
    }

    /**
     * Request Success
     * @param {AxiosRequestConfig} config
     * @memberof ApiClient
     */
    requestSuccess = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
        let token;
        const { scopes } = this.config;

        try {
            token = await getIdToken(scopes);
        } catch (e) {
            console.log(e instanceof InteractionRequiredAuthError);
            console.group('TOKEN REQUEST FAILURE');
            console.error(e);
            console.error(config);
            console.groupEnd();
            await this.authProvider.acquireTokenRedirect({ scopes });
        }

        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        };
        return config;
    };

    requestFail(error: any): Promise<any> {
        return Promise.reject(error);
    }

    responseSuccess(res: AxiosResponse): AxiosResponse<any> {
        return res;
    }

    responseFail(res: AxiosError): Promise<AxiosError> {
        console.error(res.response?.status, res.request.responseURL, res.response?.data);
        return Promise.reject(res);
    }
}

export default ApiClient;
